import axios from "axios";
import { notify } from "./util/helpers";

const urlLookup = {
  adult: {
    development: "https://devapi.rosehealth.com",
    staging: "https://stagingapi.precisebh.com",
    production: "https://api.rosehealth.com",
  },
  youth: {
    development: "https://youthdevapi.rosehealth.com",
    staging: "https://youthstagingapi.precisebh.com",
    production: "https://youthapi.rosehealth.com",
    preprod: "https://apiyouthpreprod.precisebh.com",
  },
};

export const BASE_URL =
  process.env.REACT_APP_API_URL ||
  urlLookup[process.env.REACT_APP_DASHBOARD_TYPE]?.[process.env.REACT_APP_ENV];

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (localStorage.access && !config.headers.Authorization && !config.headers.authorization) {
      config.headers.Authorization = `JWT ${localStorage.access}`;
    }
    if (config.params && typeof config.params === "object") {
      const cleanParams = {};
      for (const [key, value] of Object.entries(config.params)) {
        if (value !== undefined && value !== null && !Number.isNaN(value) && value !== "NaN" && value !== "undefined") {
          cleanParams[key] = value;
        }
      }
      config.params = cleanParams;
    }
    return config;
  },
  (error) => {
    console.log("error: " + error);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    //* Additional Interceptor Logic for response goes here
    return response;
  },
  (error) => {
    if (error.response) {
      console.error("API Error Response:", error.response?.config?.url, error.response?.status, error.response?.data);
      if (error.response.status === 401) {
        // Handle 401 error, e.g. logout user
        // store.dispatch(logout());
        if (
          error.response?.data?.detail !==
          "Given token not valid for any token type"
        ) {
          notify(
            error.response?.data?.detail || "Something went wrong!",
            "info"
          );
        }
      } else if (error.response.status === 406) {
        notify(
          error.response?.data?.detail || "Something went wrong!",
          "info"
        );
      } else if (error.response.status === 403) {
        notify(
          error.response?.data?.detail || "Something went wrong!",
          "info"
        );
      } else if (error.response.status === 429) {
        notify(error.response?.data?.detail || "Too Many Incorrect Attempt",
          "info")
      }
    }
    return Promise.reject(error);
  }
);

export const CMS_BASE_URL = "/api/cms";

export default axiosInstance;
